import React, { FC } from 'react';
import Form from 'components/Form';

import { SagrotanPageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Sagrotan: FC<SagrotanPageProps> = ({ pageContext, location }) => (
  <Form {...{ ...pageContext, location }} />
);

export default Sagrotan;
